import { render } from "./EquipmentCard.vue?vue&type=template&id=dc924628"
import script from "./EquipmentCard.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EquipmentCard.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script